<template>
  <b-collapse :id="collapseId" class="nav-collapse">
    <div class="nav-collapse__inner">
      <div class="nav-collapse__inner__box">
        <ul class="nav-collapse-list">
          <li
            v-for="route in configRoutes.navRoutes"
            :key="route.id"
            class="nav-collapse-list__item"
            @click="closeCollapse"
          >
            <router-link
              class="nav-collapse-list__item__link"
              :to="{ path: route.routePath }"
            >
              {{ route.routeName }}
            </router-link>
          </li>
        </ul>
        <ul class="nav-collapse-list-social">
          <li
            v-for="route in configRoutes.socialRoutes"
            :key="route.id"
            class="nav-collapse-list-social__item"
          >
            <a
              :href="route.routePath"
              target="_blank"
              class="nav-collapse-list-social__item__link"
            >
              {{ route.routeName }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </b-collapse>
</template>
<script>
import configRoutes from '../../router/configRoutes';
export default {
  name: 'AppNavCollapse',
  props: {
    collapseId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      configRoutes: configRoutes
    };
  },
  methods: {
    closeCollapse(e) {
      this.$emit('trigger-collapse', e);
    }
  }
};
</script>
<style scoped lang="scss">
@import '@/assets/sass/components/_nav-collapse.scss';
</style>
